import Carousel from '@stimulus-components/carousel'
import Swiper from 'swiper/bundle'

export default class CarouselStimulusController extends Carousel {
  static values = {
    slidesPerView: Number,
    thumbsSlider: String,
  };

  static targets = [
    'swiperPagination',
    'swiperButtonPrev',
    'swiperButtonNext',
  ];

  connect() {
    this.initCarousel();
  }

  disconnect() {
    this.swiper?.destroy();
    this.thumbsSwiper?.destroy();
    this.swiper = undefined;
    this.thumbsSwiper = undefined;
  }

  initCarousel() {
    let navigationOptions = false;
    let paginationOptions = false;
    let thumbsOptions = false;

    if (this.hasSwiperButtonNextTarget && this.hasSwiperButtonPrevTarget) {
      navigationOptions = {
        nextEl: this.swiperButtonNextTarget,
        prevEl: this.swiperButtonPrevTarget,
      }
    }

    if (this.hasSwiperPaginationTarget) {
      paginationOptions = {
        el: this.swiperPaginationTarget,
        type: 'bullets',
        clickable: true,
      }
    }

    if (this.hasThumbsSliderValue) {
      const thumbsElement = document.getElementById(this.thumbsSliderValue);
      if (thumbsElement) {
        this.thumbsSwiper = new Swiper(thumbsElement, {
          slidesPerView: 4,
          spaceBetween: 8,
          watchSlidesProgress: true,
          freeMode: true,
        });
        thumbsOptions = { swiper: this.thumbsSwiper };
      }
    }

    this.swiper = new Swiper(this.element, {
      loop: true,
      slidesPerView: this.slidesPerViewValue,
      spaceBetween: 4,
      navigation: navigationOptions,
      pagination: paginationOptions,
      thumbs: thumbsOptions,
      threshold: 0,
    });
  }
}
